const ctaTitleOptions = [
  'Book Now',
  'Inquire Now',
  'Learn More',
  'None',
  'Other',
].map(opt => ({ id: opt, name: opt }));

export default ctaTitleOptions;
